module.exports = __webpack_public_path__ + "static/media/paraphrase.104f7745.png";